function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext, useEffect, useState } from 'react';
import { CarouselContext } from './CarouselContext';
import { IndicatorContainer, Indicator as IndicatorElement } from './elements';
export const SlideIndicator = props => {
  var _carouselContainer$cu;
  const [currentSlides, setCurrentSlides] = useState([]);
  const {
    variant,
    carouselContainer,
    elementWidth,
    bleedElements
  } = useContext(CarouselContext);
  useEffect(() => {
    const carousel = carouselContainer.current;
    if (!carousel) {
      return;
    }
    const rightOffset = variant === 'element' || variant === 'overflow' ? parseFloat(elementWidth) * 16 - carousel.offsetWidth : 0;
    setCurrentSlides([]);
    const observer = new IntersectionObserver(entries => entries.forEach(({
      target,
      isIntersecting
    }) => {
      const slideIndex = target.auiCarouselSlideIndex;
      setCurrentSlides(currentSlides => isIntersecting ? [...currentSlides, slideIndex] : currentSlides.filter(i => i !== slideIndex));
    }), {
      root: carousel,
      rootMargin: `0px ${rightOffset}px 0px 0px`,
      threshold: 0.1
    });
    Array.from(carousel.children).forEach((slide, i) => {
      slide.auiCarouselSlideIndex = i;
      observer.observe(slide);
    });
    return () => observer.disconnect();
  }, [variant, carouselContainer, elementWidth, bleedElements]);
  const numIndicators = (((_carouselContainer$cu = carouselContainer.current) === null || _carouselContainer$cu === void 0 ? void 0 : _carouselContainer$cu.children) ?? []).length - 2 * bleedElements;
  return /*#__PURE__*/React.createElement(IndicatorContainer, _extends({}, props, {
    "data-testid": "carousel-indicator"
  }), Array.from({
    length: numIndicators
  }).map((_, i) => /*#__PURE__*/React.createElement(IndicatorElement, {
    key: i,
    $isActive: i === Math.max(...currentSlides)
  })));
};